<template>
  <div id="app" class="d-flex flex-column h-100">
    <nav-bar />
    <div class="flex-grow-1 flow-container">
      <error />
      <div class>
        <router-view />
      </div>
    </div>
    <!-- <footer class="text-center p-3" style="position:fixed;top:95%;width:100%">
      <p>
        Copyright (c) care.ai 2020
      </p>
    </footer>-->
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import NavBar from "./components/NavBar";
import Error from "./components/Error";
import VueTagsInput from "@johmun/vue-tags-input";
import { BootstrapVue } from "bootstrap-vue";
import moment from "moment";
import VueKonva from 'vue-konva';
import VueMask from "v-mask";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(VueToast);
Vue.use(BootstrapVue);
Vue.use(VueKonva);
Vue.use(VueMask);
Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY hh:mm a");
  }
});

export default {
  components: {
    NavBar,
    VueTagsInput,
    Error
  }
};
</script>

<style>
nav {
  background-color: #1f8ac3 !important;
  color: #fff !important;
}
div.logo {
  background-image: url(https://care.ai/images/emblem-2.png);
  width: 5rem;
  height: 2.25rem;
  background-repeat: no-repeat;
  background-size: cover;
}
footer {
  background-color: #1f8ac3 !important;
  color: #fff !important;
}
.flow-container {
  /*  width: 1150px !important;
  margin: -48px -28px -28px -16px !important; */
  /*  margin-top: 40px;
  margin-bottom: 40px; */
  /* max-width: 1550px !important;  */

  margin: 0px 0px 0px 0px !important;
}
.nav-link-cai {
  color: #fff !important;
}
.container {
  padding-right: 0px !important;
  padding-left: 0px !important;
}

/** Timesheet Modal CSS  */
.custom-select {
  color: #6a6a6a;
}

.form-control {
  color: #6a6a6a;
}

#changeModal___BV_modal_body_ {
  color: #1dd8f6;
}

#myModal___BV_modal_body_ {
  color: #1dd8f6;
}

#myModal___BV_modal_content_ {
  color: #6a6a6a;
  border: none !important;
  -webkit-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  -moz-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
}

.modal-header .close {
  color: #484848;
  font-size:18px;
}

.modal-content{
  font-family: 'GTWalsheimPro-Regular';
  box-shadow:0px 3px 10px #00333B29;
}

#myModal___BV_modal_title_ {
  color: white;
  font-weight: 200;
}

#changeModal___BV_modal_title_ {
  color: white;
  font-weight: 200;
}

#myModal___BV_modal_footer_ .btn {
  background-color: #1dd8f6;
  border: none;
  border-radius: 5px;
}

#changeModal___BV_modal_footer_ .btn {
  background-color: #1dd8f6;
  border: none;
  border-radius: 5px;
}

.modal-header {
  background-color: #f7f7f7;
  padding:12px 15px;
  align-items:center;
}

.modal-footer {
  background-color: #fff !important;
  min-height: 20px;
  box-shadow: none;
}
.modal-footer .btn{
  border:none;
  outline:none;
}
.modal-footer .btn-primary:hover{
  background-color:#3288D2;
}

.h-100 {
  overflow-x: hidden;
}
#addModal___BV_modal_title_,
#editModal___BV_modal_title_ {
  color: #484848;
  font-weight: 400;
  font-size:15px;
}

/* #addModal___BV_modal_body_,
#editModal___BV_modal_body_ {
  color: #1dd8f6;
} */

.form-control {
  color: #6a6a6a;
}

/* #addModal___BV_modal_footer_ .btn,
#editModal___BV_modal_footer_ .btn {
  background-color: #1dd8f6;
  border: none;
  border-radius: 5px;
} */

.modal-header {
  background-color: #f7f7f7;
  padding:12px 15px;
  align-items:center;
}

.addBtn {
  background: #ffffff !important;
  padding: 0px 10px !important;
  border: 0px !important;
}

body .v-toast__item--error {
  background-color: #f16161;
}
body .v-toast__item--info {
  background-color: #484848;
}
</style>
